import MedicalBagIcon from '@/components/v2/icons/MedicalBagIcon.vue'
import PhoneIcon from '@/components/v2/icons/PhoneIcon.vue'
import QRCodeIcon from '@/components/v2/icons/QRCodeIcon.vue'
import CircleIcon from '@/v2/components/ui/icon/components/CircleIcon.vue'
import SquareIcon from '@/v2/components/ui/icon/components/SquareIcon.vue'
import AccountIcon from './components/AccountIcon.vue'
import AccountTreeIcon from './components/AccountTreeIcon.vue'
import AddIcon from './components/AddIcon.vue'
import AiStarIcon from './components/AiStarIcon.vue'
import AlertIcon from './components/AlertIcon.vue'
import ArchiveIcon from './components/ArchiveIcon.vue'
import ArrowBackIcon from './components/ArrowBackIcon.vue'
import ArrowForwardIcon from './components/ArrowForwardIcon.vue'
import ArrowIcon from './components/ArrowIcon.vue'
import AssignmentIcon from './components/AssignmentIcon.vue'
import BabyIcon from './components/BabyIcon.vue'
import BlockIcon from './components/BlockIcon.vue'
import BookIcon from './components/BookIcon.vue'
import CalculateIcon from './components/CalculateIcon.vue'
import CalculatorIcon from './components/CalculatorIcon.vue'
import CalendarClockIcon from './components/CalendarClockIcon.vue'
import CalendarIcon from './components/CalendarIcon.vue'
import CalendarMonthIcon from './components/CalendarMonthIcon.vue'
import CancelSendIcon from './components/CancelSendIcon.vue'
import CelebrationIcon from './components/CelebrationIcon.vue'
import CheckIcon from './components/CheckIcon.vue'
import CheckStarsIcon from './components/CheckStarsIcon.vue'
import ChevronDoubleDownIcon from './components/ChevronDoubleDownIcon.vue'
import ChevronDoubleLeftIcon from './components/ChevronDoubleLeftIcon.vue'
import ChevronDoubleRightIcon from './components/ChevronDoubleRightIcon.vue'
import ChevronDown from './components/ChevronDown.vue'
import ChevronLeftIcon from './components/ChevronLeftIcon.vue'
import ChevronRightIcon from './components/ChevronRightIcon.vue'
import ChevronUpIcon from './components/ChevronUpIcon.vue'
import ClinicalNotesIcon from './components/ClinicalNotesIcon.vue'
import CloseIcon from './components/CloseIcon.vue'
import ConnectWithoutContactIcon from './components/ConnectWithoutContactIcon.vue'
import ContentPasteIcon from './components/ContentPasteIcon.vue'
import CopyIcon from './components/CopyIcon.vue'
import CorporativeIcon from './components/CorporativeIcon.vue'
import DashboardIcon from './components/DashboardIcon.vue'
import DatabaseIcon from './components/DatabaseIcon.vue'
import DatabaseSearchIcon from './components/DatabaseSearchIcon.vue'
import DeleteIcon from './components/DeleteIcon.vue'
import DescriptionIcon from './components/DescriptionIcon.vue'
import DiagnosisIcon from './components/DiagnosisIcon.vue'
import DoorOpenIcon from './components/DoorOpenIcon.vue'
import DotIcon from './components/DotIcon.vue'
import DownloadIcon from './components/DownloadIcon.vue'
import EarthIcon from './components/EarthIcon.vue'
import EditIcon from './components/EditIcon.vue'
import EggHeartIcon from './components/EggHeartIcon.vue'
import ElderlyIcon from './components/ElderlyIcon.vue'
import EventIcon from './components/EventIcon.vue'
import ExtensionIcon from './components/ExtensionIcon.vue'
import ExternalLinkIcon from './components/ExternalLinkIcon.vue'
import FavoriteIcon from './components/FavoriteIcon.vue'
import FilterIcon from './components/FilterIcon.vue'
import GridViewIcon from './components/GridViewIcon.vue'
import GroupsIcon from './components/GroupsIcon.vue'
import HealthCrossIcon from './components/HealthCrossIcon.vue'
import HomeHealthIcon from './components/HomeHealthIcon.vue'
import HomeworkIcon from './components/HomeworkIcon.vue'
import HospitalIcon from './components/HospitalIcon.vue'
import HouseIcon from './components/HouseIcon.vue'
import ImagesIcon from './components/ImagesIcon.vue'
import InfoIcon from './components/InfoIcon.vue'
import KintsuLogoIcon from './components/KintsuLogoIcon.vue'
import LifebuoyIcon from './components/LifebuoyIcon.vue'
import LinkedinIcon from './components/LinkedinIcon.vue'
import LinkIcon from './components/LinkIcon.vue'
import LoadingIcon from './components/LoadingIcon.vue'
import LocalPharmacyIcon from './components/LocalPharmacyIcon.vue'
import LogoutIcon from './components/LogoutIcon.vue'
import MagnifyIcon from './components/MagnifyIcon.vue'
import MailIcon from './components/MailIcon.vue'
import MedicalInformationIcon from './components/MedicalInformationIcon.vue'
import MedicalPrescriptionIcon from './components/MedicalPrescriptionIcon.vue'
import MedicationIcon from './components/MedicationIcon.vue'
import MenuIcon from './components/MenuIcon.vue'
import MoreHorizontalIcon from './components/MoreHorizontalIcon.vue'
import NewsIcon from './components/NewsIcon.vue'
import NotesIcon from './components/NotesIcon.vue'
import PatientIcon from './components/PatientIcon.vue'
import PdfIcon from './components/PdfIcon.vue'
import PencilIcon from './components/PencilIcon.vue'
import PillIcon from './components/PillIcon.vue'
import PlusStarsIcon from './components/PlusStarsIcon.vue'
import PrescriptionsIcon from './components/PrescriptionsIcon.vue'
import PrinterIcon from './components/PrinterIcon.vue'
import QuickReferenceIcon from './components/QuickReferenceIcon.vue'
import RenewIcon from './components/RenewIcon.vue'
import RheumatologyIcon from './components/RheumatologyIcon.vue'
import RoundedCancelIcon from './components/RoundedCancelIcon.vue'
import RoundedCheckIcon from './components/RoundedCheckIcon.vue'
import ScheduleIcon from './components/ScheduleIcon.vue'
import ScienceIcon from './components/ScienceIcon.vue'
import SearchPhysicianIcon from './components/SearchPhysicianIcon.vue'
import SendIcon from './components/SendIcon.vue'
import SettingsIcon from './components/SettingsIcon.vue'
import ShareIcon from './components/ShareIcon.vue'
import ShieldCheckIcon from './components/ShieldCheckIcon.vue'
import ShieldFail from './components/ShieldFail.vue'
import ShieldLock from './components/ShieldLock.vue'
import ShieldQuestionIcon from './components/ShieldQuestionIcon.vue'
import SignatureIcon from './components/SignatureIcon.vue'
import SignPostIcon from './components/SignPostIcon.vue'
import SimpleAiStarIcon from './components/SimpleAiStarIcon.vue'
import SmsIcon from './components/SmsIcon.vue'
import SortAscendingIcon from './components/SortAscendingIcon.vue'
import SortDesscendingIcon from './components/SortDesscendingIcon.vue'
import SortIcon from './components/SortIcon.vue'
import StethoscopeIcon from './components/StethoscopeIcon.vue'
import StraightenIcon from './components/StraightenIcon.vue'
import SupportContactIcon from './components/SupportContactIcon.vue'
import SyringeIcon from './components/SyringeIcon.vue'
import ThumbsDownIcon from './components/ThumbsDownIcon.vue'
import ThumbsUpIcon from './components/ThumbsUpIcon.vue'
import TroubleshootIcon from './components/TroubleshootIcon.vue'
import UploadIcon from './components/UploadIcon.vue'
import VaccinesIcon from './components/VaccinesIcon.vue'
import VisibilityIcon from './components/VisibilityIcon.vue'
import VisibilityOffIcon from './components/VisibilityOffIcon.vue'
import WarningIcon from './components/WarningIcon.vue'
import WeightIcon from './components/WeightIcon.vue'
import WhatsappIcon from './components/WhatsappIcon.vue'
import WorkspaceIcon from './components/WorkspaceIcon.vue'

export const iconComponentNameMap = {
  account: () => AccountIcon,
  'account-tree': () => AccountTreeIcon,
  add: () => AddIcon,
  'ai-star': () => AiStarIcon,
  'simple-ai-star': () => SimpleAiStarIcon,
  alert: () => AlertIcon,
  assignment: () => AssignmentIcon,
  archive: () => ArchiveIcon,
  arrow: () => ArrowIcon,
  'arrow-back': () => ArrowBackIcon,
  'arrow-forward': () => ArrowForwardIcon,
  baby: () => BabyIcon,
  block: () => BlockIcon,
  book: () => BookIcon,
  calculate: () => CalculateIcon,
  calculator: () => CalculatorIcon,
  calendar: () => CalendarIcon,
  'calendar-clock': () => CalendarClockIcon,
  'calendar-month': () => CalendarMonthIcon,
  'cancel-send': () => CancelSendIcon,
  celebration: () => CelebrationIcon,
  check: () => CheckIcon,
  'check-stars': () => CheckStarsIcon,
  'chevron-double-left': () => ChevronDoubleLeftIcon,
  'chevron-double-right': () => ChevronDoubleRightIcon,
  'chevron-double-down': () => ChevronDoubleDownIcon,
  'chevron-down': () => ChevronDown,
  'chevron-left': () => ChevronLeftIcon,
  'chevron-right': () => ChevronRightIcon,
  'chevron-up': () => ChevronUpIcon,
  circle: () => CircleIcon,
  'clinical-notes': () => ClinicalNotesIcon,
  close: () => CloseIcon,
  'connect-without-contact': () => ConnectWithoutContactIcon,
  'content-paste': () => ContentPasteIcon,
  copy: () => CopyIcon,
  corporative: () => CorporativeIcon,
  dashboard: () => DashboardIcon,
  database: () => DatabaseIcon,
  'database-search': () => DatabaseSearchIcon,
  delete: () => DeleteIcon,
  description: () => DescriptionIcon,
  diagnosis: () => DiagnosisIcon,
  'door-open': () => DoorOpenIcon,
  dot: () => DotIcon,
  download: () => DownloadIcon,
  earth: () => EarthIcon,
  edit: () => EditIcon,
  'egg-heart': () => EggHeartIcon,
  elderly: () => ElderlyIcon,
  event: () => EventIcon,
  extension: () => ExtensionIcon,
  'external-link': () => ExternalLinkIcon,
  favorite: () => FavoriteIcon,
  filter: () => FilterIcon,
  'grid-view': () => GridViewIcon,
  groups: () => GroupsIcon,
  'health-cross': () => HealthCrossIcon,
  'home-health': () => HomeHealthIcon,
  homework: () => HomeworkIcon,
  hospital: () => HospitalIcon,
  house: () => HouseIcon,
  images: () => ImagesIcon,
  info: () => InfoIcon,
  'kintsu-logo': () => KintsuLogoIcon,
  lifebuoy: () => LifebuoyIcon,
  link: () => LinkIcon,
  linkedin: () => LinkedinIcon,
  loading: () => LoadingIcon,
  'local-pharmacy': () => LocalPharmacyIcon,
  logout: () => LogoutIcon,
  mail: () => MailIcon,
  'medical-bag': () => MedicalBagIcon,
  medication: () => MedicationIcon,
  'medical-information': () => MedicalInformationIcon,
  'medical-prescription': () => MedicalPrescriptionIcon,
  magnify: () => MagnifyIcon,
  menu: () => MenuIcon,
  'more-horizontal': () => MoreHorizontalIcon,
  news: () => NewsIcon,
  notes: () => NotesIcon,
  patient: () => PatientIcon,
  pdf: () => PdfIcon,
  pencil: () => PencilIcon,
  phone: () => PhoneIcon,
  pill: () => PillIcon,
  'plus-stars': () => PlusStarsIcon,
  prescriptions: () => PrescriptionsIcon,
  printer: () => PrinterIcon,
  'quick-reference': () => QuickReferenceIcon,
  qrcode: () => QRCodeIcon,
  renew: () => RenewIcon,
  rheumatology: () => RheumatologyIcon,
  'rounded-cancel': () => RoundedCancelIcon,
  'rounded-check': () => RoundedCheckIcon,
  schedule: () => ScheduleIcon,
  science: () => ScienceIcon,
  'search-physician': () => SearchPhysicianIcon,
  send: () => SendIcon,
  settings: () => SettingsIcon,
  share: () => ShareIcon,
  'shield-check': () => ShieldCheckIcon,
  'shield-fail': () => ShieldFail,
  'shield-lock': () => ShieldLock,
  'shield-question': () => ShieldQuestionIcon,
  'sign-post': () => SignPostIcon,
  signature: () => SignatureIcon,
  sms: () => SmsIcon,
  'sort-ascending': () => SortAscendingIcon,
  'sort-descending': () => SortDesscendingIcon,
  sort: () => SortIcon,
  square: () => SquareIcon,
  stethoscope: () => StethoscopeIcon,
  straighten: () => StraightenIcon,
  'support-contact': () => SupportContactIcon,
  syringe: () => SyringeIcon,
  'thumbs-down': () => ThumbsDownIcon,
  'thumbs-up': () => ThumbsUpIcon,
  troubleshoot: () => TroubleshootIcon,
  upload: () => UploadIcon,
  vaccines: () => VaccinesIcon,
  visibility: () => VisibilityIcon,
  'visibility-off': () => VisibilityOffIcon,
  warning: () => WarningIcon,
  weight: () => WeightIcon,
  whatsapp: () => WhatsappIcon,
  workspace: () => WorkspaceIcon,
} as const

export type IconSlug = keyof typeof iconComponentNameMap

export const iconSlugs = Object.keys(iconComponentNameMap) as Array<IconSlug>
